<div class="total-vacations-element" *ngIf="totalElement && totalElement.total">
  <div class="d-flex d-align-center">
    <span class="total-vacations-element__circle"></span>
    <span class="total-vacations-element__description">{{ totalElement.dayType?.name }}</span>
  </div>
  <div class="total-vacations-element__total">{{ totalElement.total }}</div>
</div>
